import { SVGProps, Ref, forwardRef } from 'react';

export const BriefcaseOutlinedSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.724 5h6.552C14.608 3.607 13.628 2.8 12 2.8S9.392 3.607 8.724 5m8.506.013C16.38 2.68 14.75 1 12 1S7.621 2.68 6.77 5.013C.88 5.147 0 6.433 0 13v2c0 7 1 8 8 8h8c7 0 8-1 8-8v-2c0-6.567-.88-7.853-6.77-7.987M1.813 11.8h20.375c.024 1.066.012 2.133.012 3.2 0 1.736-.065 2.968-.235 3.87-.166.884-.402 1.272-.613 1.482s-.598.447-1.482.613c-.902.17-2.134.235-3.87.235H8c-1.736 0-2.968-.065-3.87-.235-.884-.166-1.272-.402-1.482-.613s-.447-.598-.614-1.482c-.17-.902-.234-2.134-.234-3.87 0-1.066-.012-2.134.013-3.2M22.088 10q-.049-.48-.123-.87c-.166-.884-.402-1.272-.613-1.482s-.598-.447-1.482-.613c-.902-.17-2.134-.235-3.87-.235H8c-1.736 0-2.968.065-3.87.235-.884.166-1.272.402-1.482.613s-.447.598-.614 1.482q-.073.39-.122.87zM15.5 16h-7v-1.8h7z"
                fill="currentColor"
            />
        </g>
    </svg>
));
BriefcaseOutlinedSize24Glyph.displayName = 'BriefcaseOutlinedSize24Glyph';
